import type { HotelogixCompareComponentProps } from './HotelogixCompareComponent';

export const HotelogixCompareComponent = {
    MountAsync: async (target: HTMLElement, props: HotelogixCompareComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { HotelogixCompareComponent } = await import('./HotelogixCompareComponent');
        return await mountReactComponentAsync(target, HotelogixCompareComponent, props);
    }
};
